import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'

const MatchSearchResultItemHeader = () => (
    <div className="suggested-match-item suggested-match-item-header">
        <div className="submission-date">Submission Date</div>
        <div className="recording-groups-count">
            Recording Groups
            <CustomToolTip
                type="?"
                inverse
                info={
                    <>
                        This column shows the number of recording groups for each submitted match suggestion. Recordings
                        are grouped together based on similar data, and may be from multiple digital service providers
                        (DSPs).
                    </>
                }
            />
        </div>
        <div className="work-title">Work Title</div>
        <div className="song-code">MLC Song Code</div>
        <div className="writers">Writers</div>
        <div className="status-component">Status</div>
    </div>
)

export default MatchSearchResultItemHeader
